import { AmbientLight, Camera, DirectionalLight, PerspectiveCamera, Scene, WebGLRenderer } from "three";

export abstract class GraphicsContext {

    public scene: Scene;
    public camera: Camera;
    public renderer: WebGLRenderer;
    public containerElement: HTMLElement;

    constructor(scene: Scene, camera: Camera, renderer: WebGLRenderer, containerElement: HTMLElement) {
        this.scene = scene;
        this.camera = camera;
        this.renderer = renderer;
        this.containerElement = containerElement;
    }

    dispose() {
        this.renderer.dispose();
    }

    resizeCanvasToDisplaySize() {}
}
